const module = { name: 'theater/details/shared/formatFilters', exports: {} }; const exports = module.exports;



import { Fandango as Fandango_context } from 'require-core';

const { context: { device: { isMobile } } } = Fandango_context;


import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from 'require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


import { global_utils_functionUtils as global_utils_functionUtils_noop } from 'require-global';

const { noop } = global_utils_functionUtils_noop;


import { global_consts as global_consts_QueryParams } from 'require-core';

const { QueryParams } = global_consts_QueryParams;


import { default as formatFilter } from 'swug-fdRequire-call:movie/shared/formatFilter';



import { Fandango_queryUtil as queryUtil } from 'require-core';



import { default as historyStates } from 'swug-fdRequire-call:movie/shared/historyStates';



const Selectors = {
    CONTAINER: '#lazyload-format-filters',
    FILTER_BTNS: '.js-format-filter',
}


const Styles = {
    SELECTED: 'format-filter__list-item--active',
}


const Attribs = {
    CHECKED: 'aria-checked',
}


let onChangeHandler = () => { }


let activeFilter = null
function updateSelected(ele) {
    document.querySelectorAll(Selectors.FILTER_BTNS).forEach((btn) => {
        const parent = btn.parentElement;
        if (btn === ele) {
            btn.setAttribute(Attribs.CHECKED, true);
            parent.classList.add(Styles.SELECTED);
        }
        else {
            btn.removeAttribute(Attribs.CHECKED);
            parent.classList.remove(Styles.SELECTED);
        }
    });
}
function onClick() {
    const format = this.dataset.format;
    if (!format || format === activeFilter) {
        return;
    }
    activeFilter = format;
    updateSelected(this);
    const allFormat = formatFilter.FormatFilters.ALL;
    historyStates.push(historyStates.HistoryEventTypes.FORMAT_FILTER, format === allFormat ? null : format);
    onChangeHandler(format);
    track({
        event: EventTypes.FORMAT_CLICKS,
        formatSelected: format,
        platform: isMobile ? 'fandango mobile web' : 'fandango web'
    });
}
function attachEvents() {
    document.querySelectorAll(Selectors.FILTER_BTNS)
        .forEach(filter => filter.addEventListener('click', onClick));
}
function getActiveFilter() {
    if (!activeFilter) {
        activeFilter = decodeURIComponent(queryUtil.getParam(QueryParams.FORMAT) || formatFilter.FormatFilters.ALL);
    }
    return activeFilter;
}
function load(formats, onChange) {
    if (!Array.isArray(formats) || !formats.length) {
        formatFilter.hide();
        return;
    }
    const viewModel = {
        all: [...formats],
        availableFormats: formats,
    };
    activeFilter = getActiveFilter();
    const markup = formatFilter.getMarkup(viewModel, activeFilter, true);
    const container = document.querySelector(Selectors.CONTAINER);
    if (!markup || !container) {
        return;
    }
    container.innerHTML = markup;
    onChangeHandler = noop(onChange);
    attachEvents();
    historyStates.push(historyStates.HistoryEventTypes.FORMAT_FILTER, activeFilter);
}
module.exports = {
    getActiveFilter,
    load,
};
export default module.exports;